import axios from 'axios';

export const logUserAction = (page, room, mood, theme, light, size, colour, rank, finish, volume, colourSelected, orderPlaced) => {
    const token = localStorage.getItem('authToken');

    const timestamp = Date.now();
    const timestampFormatted = new Date(timestamp).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).replace(",", "");

    if (token) {
        axios.post('https://vibraint.net/api/users/logUserActions', {
            token: token,
            page: page,
            room: room,
            mood: mood,
            theme: theme,
            light: light,
            size: size,
            colour: colour,
            rank: rank,
            finish: finish,
            volume: volume,
            colourSelected: colourSelected,
            orderPlaced: orderPlaced,
            timestamp: timestampFormatted,
        })
        .catch(error => {
            console.error('Error logging action:', error);
        });
    }
};

export const logCompetitionEntry = (name, email, favouriteColour) => {
    const token = localStorage.getItem('authToken');

    const timestamp = Date.now();
    const timestampFormatted = new Date(timestamp).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).replace(",", "");

    if (token) {
        axios.post('https://vibraint.net/api/users/logCompetitionEntries', {
            token: token,
            name: name,
            email: email,
            favouriteColour: favouriteColour,
            timestamp: timestampFormatted
        })
        .catch(error => {
            console.error('Error logging competition entry:', error);
        });
    }
};